// extracted by mini-css-extract-plugin
module.exports = {"Content":"SsoView__Content__2XUjx"};